import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivityRegistryDto } from './activity-registry-dto';

@Injectable()
export class ActivityRegistryService {
  constructor(private http: HttpClient) {}

  getActivityRegistryData(): Observable<ActivityRegistryDto> {
    const activityRegistryDataUrl = '/activities';
    return this.http.get<ActivityRegistryDto>(activityRegistryDataUrl);
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-registry-service/activity-registry.service.ts